import type { InjectionKey } from 'vue'

export interface AccordeonContext {
  isOpen: Ref<boolean>
  toggle: (value?: boolean) => void
  wrapperRef: Ref<HTMLDivElement | undefined>
}

export const AccordionContextSymbol = Symbol('AccordionContext') as InjectionKey<AccordeonContext>
